module.exports = __webpack_public_path__ + "static/media/sidebar-2.b2c59965.jpg";